import React from 'react';
import '../styles/app/people.css';

const getInitials = (name) => {
  if (!name) return '?';
  const parts = name.trim().split(' ');
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
};

// Circular avatar for fighters, users, and pool leaders. Falls back to
// initials when no image is available or the image fails to load.
function OctaAvatar({ src, name, initials, size = 64, ring = false, ringColor = 'var(--primary)', bg }) {
  const label = initials || getInitials(name);
  const [imgFailed, setImgFailed] = React.useState(false);
  const showImage = src && !imgFailed;

  return (
    <div
      className="octa-avatar"
      style={{
        width: size,
        height: size,
        fontSize: Math.round(size * 0.36),
        background: bg || 'linear-gradient(135deg, rgba(var(--primary-rgb), 0.25), rgba(0,0,0,0.4))',
        boxShadow: ring ? `0 0 0 3px var(--bg-dark), 0 0 0 5px ${ringColor}` : 'none',
      }}
    >
      {showImage ? (
        <img
          src={src}
          alt={name || 'avatar'}
          onError={() => setImgFailed(true)}
        />
      ) : (
        <span>{label}</span>
      )}
    </div>
  );
}

export default OctaAvatar;
